import { Children } from "react"
import { useSelector } from "react-redux"
import { TextSection } from "../components"
import { getText } from "../redux"
import "../style/ServicesSection.scss"
import { splitText } from "../utils"

function SectionsList({ services, mainDescription }) {
  const sectionData = useSelector(state => getText(state, "approaches"))

  const servicesList = services.map(service => {
    const { title, icon, description } = service

    return (
      <div className="servicesSection__item">
        <img src={icon} alt={title} loading="lazy" />
        <h3 className="servicesSection__item__title">{title}</h3>
        <p className="servicesSection__item__description">
          {splitText(description)}
        </p>
      </div>
    )
  })

  return (
    <div className="servicesSection">
      <TextSection data={{ ...sectionData, description: mainDescription }} />

      <div className="servicesSection__container">
        {Children.toArray(servicesList)}
      </div>
    </div>
  )
}

export default SectionsList
